var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/anonymous/Desktop/components/Menu.js",
  _this = this;
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { IconChevronDown, IconChevronUp } from '@wds/icons';
import classNames from 'classnames';
import { NavBarAnonContext } from '../NavBarAnonContext.js';
import SMHeaderContext from '../../../SMHeaderContext';
export var Menu = function Menu(_ref) {
  var path = _ref.path,
    title = _ref.title,
    menuKey = _ref.menuKey,
    children = _ref.children,
    name = _ref.name,
    _onClick = _ref.onClick;
  var _useContext = useContext(NavBarAnonContext),
    color = _useContext.color,
    submenuOpened = _useContext.submenuOpened,
    toggleSubmenu = _useContext.toggleSubmenu;
  var _useContext2 = useContext(SMHeaderContext),
    excludeMenuItems = _useContext2.excludeMenuItems;
  var linksClassname = classNames("sm-header__nav-cta--".concat(color), 'sm-header__text', {
    'sm-header--open': submenuOpened === menuKey
  });
  if (excludeMenuItems.includes(name)) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, path === '' ? /*#__PURE__*/React.createElement(Box, {
    display: "inline-block",
    key: menuKey,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Box, {
    className: linksClassname,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    color: color,
    onClick: function onClick() {
      _onClick === null || _onClick === void 0 || _onClick();
      toggleSubmenu(menuKey);
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 13
    }
  }, title, submenuOpened === menuKey ? /*#__PURE__*/React.createElement(IconChevronUp, {
    size: "xs",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 17
    }
  }) : /*#__PURE__*/React.createElement(IconChevronDown, {
    size: "xs",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 17
    }
  }))), children) : /*#__PURE__*/React.createElement(Box, {
    display: "inline-block",
    className: "sm-header__nav-cta--".concat(color, " sm-header__text"),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Button, {
    key: menuKey,
    variant: "text",
    color: color,
    href: path,
    onClick: _onClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 11
    }
  }, title)));
};
Menu.propTypes = {
  path: PropTypes.string,
  title: PropTypes.string.isRequired,
  menuKey: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func
};
Menu.defaultProps = {
  path: '',
  onClick: undefined
};
export default Menu;
//# sourceMappingURL=Menu.js.map